import { Action, createReducer, on } from '@ngrx/store';
import * as AgentsActions from './agents.actions';

export interface State {
    agents: Array<object>
}

export const initialState: State = {
    agents: []
};

const reportsReducer = createReducer(
    initialState,
    on(AgentsActions.getAllAgents, state => state),
    on(AgentsActions.error, state => state)
);

export function reducer(state: State | undefined, action: Action) {
    return reportsReducer(state, action);
}